import WorkOffIcon from '@mui/icons-material/WorkOff';
import { Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { JobStatus } from '../../types';

export interface EmptyStateProps {
  status: JobStatus | undefined;
}

export default function EmptyState({ status }: EmptyStateProps) {
    const { t } = useTranslation('myJobs');

    return (
        <Root>
            <WorkOffIcon sx={{ fontSize: 64, color: 'text.secondary' }} />
            <Typography variant="h6"
                color="text.primary">
                { t(`empty.${ status || 'all' }.title`) }
            </Typography>
            <Typography variant="body2"
                color="text.secondary">
                { t(`empty.${ status || 'all' }.description`) }
            </Typography>
        </Root>
    );
}

const Root = styled(Stack)(({ theme }) => ({
    alignItems: 'center',
    gap: theme.spacing(2),
    height: '100%',
    justifyContent: 'center',
    minHeight: '400px',
    textAlign: 'center'
}));
